const state = {
  openPersonList: false,
  openMOre: false
}

const mutations = {
  // 打开编辑
  OPEN_PERSON_MODAL (state, value) {
    state.openPersonList = value
  }
}

export default {
  namespaced: true,
  mutations,
  state,
}